import { Injectable, inject } from '@angular/core';
import { Observable, map, catchError, of } from 'rxjs';
import { AiEntitlementRestApi } from '../../../infrastructure/api/ai-entitlement-rest.api';
import { AiEntitlementEntity } from '../../../domain/entities/ai-entitlement.entity';
import { UpdateAiEntitlementResult } from './update-ai-entitlement.result';

/**
 * Update AI Entitlement use case.
 * Updates the AI entitlement configuration for the current tenant.
 */
@Injectable({ providedIn: 'root' })
export class UpdateAiEntitlementUseCase {
  private readonly _api = inject(AiEntitlementRestApi);

  public execute(data: AiEntitlementEntity): Observable<UpdateAiEntitlementResult> {
    return this._api.updateAiEntitlement(data).pipe(
      map(() => ({ success: true })),
      catchError((error: { message?: string }) => of({ success: false, error: error.message })),
    );
  }
}
